import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function stripLangPrefix(path: string) {
  return path.replace(/^\/en/, '') || '/';
}

export function useScrollToTop() {
  const { pathname } = useLocation();
  const prevPath = useRef(stripLangPrefix(pathname));

  useEffect(() => {
    const current = stripLangPrefix(pathname);
    if (current !== prevPath.current) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
    prevPath.current = current;
  }, [pathname]);
}
